if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.touchStartX = 0;
        this.touchStartY = 0;

        this.addEventListener('click', (event) => {
          const previousButton = event.target.closest('.clx-product-media-modal__nav--prev');
          const nextButton = event.target.closest('.clx-product-media-modal__nav--next');

          if (previousButton) {
            event.preventDefault();
            this.changeMedia(-1);
            return;
          }

          if (nextButton) {
            event.preventDefault();
            this.changeMedia(1);
            return;
          }

          if (!window.matchMedia('(max-width: 749px)').matches) return;
          if (event.target.closest('.product-media-modal__toggle')) return;
          if (event.target.closest('.clx-product-media-modal__controls')) return;
          if (event.target.matches('.product-media-modal__content > img.active')) return;

          const tappedEmptyLightboxArea =
            event.target === this ||
            event.target.classList.contains('product-media-modal__dialog') ||
            event.target.classList.contains('product-media-modal__content');

          if (tappedEmptyLightboxArea) this.hide();
        });

        this.addEventListener(
          'touchstart',
          (event) => {
            if (!window.matchMedia('(max-width: 749px)').matches) return;
            if (event.touches.length !== 1) return;

            this.touchStartX = event.touches[0].clientX;
            this.touchStartY = event.touches[0].clientY;
          },
          { passive: true }
        );

        this.addEventListener(
          'touchend',
          (event) => {
            if (!window.matchMedia('(max-width: 749px)').matches) return;
            if (event.changedTouches.length !== 1) return;

            const deltaX = event.changedTouches[0].clientX - this.touchStartX;
            const deltaY = event.changedTouches[0].clientY - this.touchStartY;

            if (Math.abs(deltaX) < 50) return;
            if (Math.abs(deltaX) <= Math.abs(deltaY)) return;

            this.changeMedia(deltaX < 0 ? 1 : -1);
          },
          { passive: true }
        );
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      getMediaItems() {
        return Array.from(this.querySelectorAll('[data-media-id]'));
      }

      getActiveMediaIndex() {
        return this.getMediaItems().findIndex((item) => item.classList.contains('active'));
      }

      changeMedia(direction) {
        const mediaItems = this.getMediaItems();
        if (mediaItems.length <= 1) return;

        const currentIndex = this.getActiveMediaIndex();
        const safeCurrentIndex = currentIndex >= 0 ? currentIndex : 0;
        const nextIndex = (safeCurrentIndex + direction + mediaItems.length) % mediaItems.length;

        this.activateMedia(mediaItems[nextIndex], nextIndex);
      }

      showActiveMedia() {
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        if (!mediaId) return;

        const mediaItems = this.getMediaItems();
        const activeMedia = mediaItems.find((item) => item.getAttribute('data-media-id') === mediaId);
        if (!activeMedia) return;

        this.activateMedia(activeMedia, mediaItems.indexOf(activeMedia));
      }

      activateMedia(activeMedia, activeIndex) {
        const mediaItems = this.getMediaItems();
        const container = this.querySelector('[role="document"]');

        mediaItems.forEach((element) => {
          element.classList.toggle('active', element === activeMedia);
        });

        this.updateControls(activeIndex, mediaItems.length);

        if (container) {
          const isMobile = window.matchMedia('(max-width: 749px)').matches;

          container.scrollTop = 0;
          container.scrollLeft = 0;

          if (isMobile) {
            window.requestAnimationFrame(() => {
              container.scrollTop = 0;
              container.scrollLeft = 0;
            });
          } else {
            activeMedia.scrollIntoView();
            container.scrollLeft = Math.max(
              0,
              (activeMedia.width - container.clientWidth) / 2
            );
          }
        }

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }

      updateControls(activeIndex, mediaCount) {
        const controls = this.querySelector('.clx-product-media-modal__controls');
        const current = this.querySelector('.clx-product-media-modal__counter-current');
        const total = this.querySelector('.clx-product-media-modal__counter-total');

        if (!controls) return;

        controls.hidden = mediaCount <= 1;

        if (current) current.textContent = String(activeIndex + 1);
        if (total) total.textContent = String(mediaCount);
      }
    }
  );
}
